import { render, staticRenderFns } from "./base-pagination.vue?vue&type=template&id=12b348fe&"
import script from "./base-pagination.vue?vue&type=script&lang=js&"
export * from "./base-pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b348fe')) {
      api.createRecord('12b348fe', component.options)
    } else {
      api.reload('12b348fe', component.options)
    }
    module.hot.accept("./base-pagination.vue?vue&type=template&id=12b348fe&", function () {
      api.rerender('12b348fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/base-pagination.vue"
export default component.exports